/**
 * Store réactif des opens fetched depuis le Worker /me/opens.
 *
 * `cursor` = max id sync'é (sert de `since=` au prochain fetch).
 * `opens` = liste cumulée triée DESC (plus récent en premier).
 * Limit volume: on garde les 200 derniers en mémoire (suffit pour un dashboard).
 */

export interface OpenEvent {
  id: number;
  pixel_id: string;
  opened_at: number;
  country: string | null;
  region: string | null;
  city: string | null;
  user_agent: string | null;
  recipient_email: string;
  recipient_name: string | null;
  subject: string | null;
  sent_at: number;
}

interface TrackerState {
  opens: OpenEvent[];
  cursor: number;
  loading: boolean;
  lastSyncAt: number | null;   // unix ms
  error: string | null;
  /** Pixel sélectionné pour la modale détail. null = modale fermée. */
  detailPixelId: string | null;
}

export const trackerState = $state<TrackerState>({
  opens: [],
  cursor: 0,
  loading: false,
  lastSyncAt: null,
  error: null,
  detailPixelId: null,
});

const MAX_OPENS_IN_MEMORY = 200;

/** Ajoute des opens en tête, dédup par id, tronque à MAX. */
export function mergeOpens(newOpens: OpenEvent[]): void {
  if (newOpens.length === 0) return;
  const seen = new Set(trackerState.opens.map((o) => o.id));
  const fresh = newOpens.filter((o) => !seen.has(o.id));
  if (fresh.length === 0) return;

  // Le Worker retourne déjà DESC, mais on re-trie au cas où on ait des merges
  // partiels d'une autre source (push event direct au foreground par ex).
  const merged = [...fresh, ...trackerState.opens]
    .sort((a, b) => b.id - a.id)
    .slice(0, MAX_OPENS_IN_MEMORY);

  trackerState.opens = merged;

  // Le cursor avance au max id rencontré (le Worker garantit qu'il croit)
  const maxId = merged[0]?.id ?? trackerState.cursor;
  if (maxId > trackerState.cursor) trackerState.cursor = maxId;
}
